define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/RefContainer",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,RefContainer,reflection,xml,Query) {

	return declare(RefContainer, {
		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			// summary: return action to select products, defaulting to collection in context
			var	node = ctx.getNode();
			var	parent = ctx.getParent();
			var	collection, filters;

			if (parent.$Type == "MarketingCollection") {
				collection = parent;
			} else {
				var	look = node || parent;
				collection = ctx.cache.getNode(look.PrimaryCollection, true);
			}
			
			if (collection) {
				filters = new Query().Attr(xml.ATTR_NAME, xml.OP_EQUALS, collection.$Name, reflection.PATH_PARENT).getElements();
			}
			
			return lang.mixin(new Action(), {
				m_filtersView: filters,
				m_fixedQuery: new Query()
					.Attr("State", xml.OP_NOT_EQUALS, "MCState:NotAvailable"),
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "MCProducts",
					m_url: "centric://APPAREL/Views"
				})
			});
		}
	});
});